/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DocumentType = {
    AddressProof: 'ADDRESS_PROOF',
    RegistrationProof: 'REGISTRATION_PROOF',
    IdentityProof: 'IDENTITY_PROOF',
    ArticlesOfAssociation: 'ARTICLES_OF_ASSOCIATION',
    ShareholderDeclaration: 'SHAREHOLDER_DECLARATION',
    SocialContributionsCertificate: 'SOCIAL_CONTRIBUTIONS_CERTIFICATE',
    ContractOfAdhesion: 'CONTRACT_OF_ADHESION',
    DeclarationOfNonRegularActivity: 'DECLARATION_OF_NON_REGULAR_ACTIVITY',
    UboCertificate: 'UBO_CERTIFICATE',
    SelfEmploymentCertificate: 'SELF_EMPLOYMENT_CERTIFICATE'
} as const;
export type DocumentType = typeof DocumentType[keyof typeof DocumentType];


export function instanceOfDocumentType(value: any): boolean {
    for (const key in DocumentType) {
        if (Object.prototype.hasOwnProperty.call(DocumentType, key)) {
            // @ts-ignore
            if (DocumentType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DocumentTypeFromJSON(json: any): DocumentType {
    return DocumentTypeFromJSONTyped(json, false);
}

export function DocumentTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentType {
    return json as DocumentType;
}

export function DocumentTypeToJSON(value?: DocumentType | null): any {
    return value as any;
}

